import { __awaiter } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useMemo, useCallback, useEffect, useContext } from 'react';
import { AssistantClient } from './assistantClient.js';

const EMPTY_CLIENT = {
    getCookie: () => __awaiter(void 0, void 0, void 0, function* () { }),
    fetchInitSessionInfo: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            resolve({ sessionId: '', zeroStateExperienceFlag: true, chatHistory: [] });
        });
    }),
    submitFeedback: () => __awaiter(void 0, void 0, void 0, function* () { }),
    getServiceRunningStatus: () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            resolve(null);
        });
    })
};
const ClientContext = createContext({
    client: EMPTY_CLIENT,
    isHealthy: true,
    checkServiceStatus: () => __awaiter(void 0, void 0, void 0, function* () { return null; }) // Expose this function, to allow our components check service status from anywhere and update isHealthy
});
const useClient = () => useContext(ClientContext);
function ClientProvider(props) {
    const [isHealthy, setIsHealthy] = useState(true);
    const client = useMemo(() => {
        return new AssistantClient(props.endpoint, props.initData);
    }, [props.endpoint, props.initData]);
    // Define the function to check the service status by calling client's getServiceRunningStatus method.
    const checkServiceStatus = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        try {
            const data = yield client.getServiceRunningStatus();
            if (data && data.andonCordPulled === true) {
                setIsHealthy(false);
            }
            else {
                setIsHealthy(true);
            }
            return data;
        }
        catch (error) {
            console.error('Error checking service status:', error);
            setIsHealthy(true); // based on discussion, we only assume our service is not healthy on one condition: andonCordPulled called successfully with true
            return null;
        }
    }), [client]);
    // useEffect will run after the first render and when checkServiceStatus changes.
    // This makes sure we will check our system status when init our components
    useEffect(() => {
        checkServiceStatus();
    }, [checkServiceStatus]);
    return (jsx(ClientContext.Provider, { value: { client, isHealthy, checkServiceStatus }, children: props.children }));
}

export { ClientProvider, EMPTY_CLIENT, useClient };
